import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { ClipContext } from "../@types";
import { TClip } from "MVVM/@types";
import { CLIPS_RECOMMENDED, CLIPS_PROFILE } from "MVVM/GraphQL/feed";

const limit = 20;

interface FeedData {
  clipsRecommended: TClip[];
}

interface UserClipsData {
  getUser: {
    clips: {
      nodes: TClip[];
    };
  };
}

interface RecommendedClipsData {
  clipsRecommended: TClip[];
}

const FeedViewModel = (context?: ClipContext) => {
  const queryConfig = useMemo(() => {
    switch (context?.type) {
      case "profile":
        return {
          query: CLIPS_PROFILE,
          variables: {
            first: limit,
            userId: context.metadata?.userId,
            filters: {},
          },
          dataTransform: (data: UserClipsData | undefined): FeedData => ({
            clipsRecommended: data?.getUser?.clips?.nodes || [],
          }),
        };
      default:
        return {
          query: CLIPS_RECOMMENDED,
          variables: { limit },
          dataTransform: (data: RecommendedClipsData | undefined): FeedData =>
            data || { clipsRecommended: [] },
        };
    }
  }, [context]);

  const { data, error, loading } = useQuery(queryConfig.query, {
    variables: queryConfig.variables,
    fetchPolicy: "cache-and-network",
  });

  return {
    data: queryConfig.dataTransform(data),
    error,
    loading,
  };
};

export { FeedViewModel };
